import React from 'react';
import Helping from "../../helpers/Helping";

const MoneyField = ({ value }) => (<>{"$"+Helping.parseAmount(value)}</>);

export default MoneyField;